import { render } from "./CadastraClientes.vue?vue&type=template&id=3ac80036"
import script from "./CadastraClientes.vue?vue&type=script&lang=js"
export * from "./CadastraClientes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__